<template>
  <div>
    <!-- 主体内容区 -->
    <main class="container mx-auto my-8 p-4 bg-white rounded-lg shadow-lg flex flex-col lg:flex-row gap-8">

      <!-- 左侧区域 - 国家选择 -->
      <div class="w-full lg:w-2/4 bg-gray-50 p-3 rounded-lg shadow-inner">
        <h2 class="text-xl font-semibold text-gray-800 mb-6 text-left">
          选择国家/地区
        </h2>
        <div class="space-y-4" v-if="gj_data && gj_data.length > 0" v-loading="loading">
          <div class="flex items-center p-3 bg-white rounded-md shadow-sm border border-gray-200"
               v-for="(item, index) in gj_data" :key="index" @click="shop(item)">
            <input :checked="item == selectedLabelsdata" class="form-radio h-5 w-5 text-purple-600" type="radio"/>
            <!--            <img alt="美国国旗" class="w-6 h-4 ml-2"-->
            <!--                 src="https://design.gemcoder.com/staticResource/echoAiSystemImages/57f16c90b223cdcd92897965943db1a0.png"/>-->
            <label class="ml-3 text-gray-700 font-medium">
              {{ item.c_dict_label }} - {{ item.dict_label }}
            </label>
          </div>
        </div>
      </div>

      <!-- 中间区域 - 商品购买详情 -->
      <div class="w-full lg:w-3/5 bg-white p-3 rounded-lg shadow-lg">
        <h2 class="text-2xl font-bold text-gray-800 mb-6 text-left">
          商品购买
        </h2>

        <div class="product-card border border-gray-200 rounded-lg p-6 mb-6 shadow-md" v-loading="loading">
          <h3 class="text-xl font-semibold text-gray-700 mb-4 text-left">
            {{ selectedLabelsdata ? selectedLabelsdata.c_dict_label + " - " + selectedLabelsdata.dict_label : '' }}
          </h3>

          <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" v-if="gj_data && gj_data.length > 0">
            <button @click="shichang(item)"
                    class="duration-btn bg-gray-100 py-3 px-2 rounded-md transition duration-200 ease-in-out border border-gray-200"
                    :class="item == selectedOption ? 'bg-purple-600 text-white hover:bg-purple-700' : 'bg-gray-100 text-gray-700 hover:bg-purple-100 hover:text-purple-700'"
                    v-for="(item, index) in items" :key="index">
              {{ item.name }}
            </button>
          </div>
          <div class="flex justify-between items-center mb-4">
            <span class="text-gray-600">
              单价:
            </span>
            <span class="text-lg font-bold text-purple-600" id="price_us">
              ￥{{ selectedOption ? selectedOption.price : "0.00" }}
            </span>
          </div>
          <div class="flex justify-between items-center mb-6">
            <span class="text-gray-600">
              数量:
            </span>
            <input
                class="w-24 p-2 border border-gray-300 rounded-md text-center focus:ring-purple-500 focus:border-purple-500"
                min="1" type="number" value="1" v-model="total"/>
          </div>
          <div class="flex justify-between items-center border-t pt-4 border-gray-200">
            <span class="text-xl font-semibold text-gray-800">
              总价:
            </span>
            <span class="text-2xl font-bold text-purple-700" id="total_price_us">
              ￥{{ totalPrice }}
            </span>
          </div>
          <button
              class="buy-now-btn w-full bg-purple-600 text-white py-3 rounded-md mt-6 hover:bg-purple-700 transition duration-300 ease-in-out text-lg font-semibold"
              @click="shoppingCart">
            添加到购物车
          </button>
        </div>

        <h2 class="text-xl font-semibold text-gray-800 mb-6">
          帮助与支持
        </h2>
        <div class="space-y-4 text-gray-700">
          <p class="flex items-center">
            <i class="fas fa-info-circle mr-2 text-purple-600">
            </i>
            了解更多关于住宅IP的信息。
          </p>
          <p class="flex items-center">
            <i class="fas fa-question-circle mr-2 text-purple-600">
            </i>
            常见问题解答。
          </p>
          <p class="flex items-center">
            <i class="fas fa-headset mr-2 text-purple-600">
            </i>
            联系客服获取帮助。
          </p>
          <div class="border-t border-gray-200 pt-4 mt-4">
            <h3 class="font-semibold text-gray-800 mb-2">
              联系我们
            </h3>
            <p class="flex items-center">
              <i class="fas fa-envelope mr-2 text-purple-600">
              </i>
              {{ this.$email }}
            </p>
            <p class="flex items-center">
              <i class="fas fa-phone mr-2 text-purple-600">
              </i>
              {{ this.$tel }}
            </p>
          </div>
        </div>

      </div>

      <!-- 购物车区域 -->
      <div class="lg:w-3/5 product-card border border-gray-200 rounded-lg p-3 mb-6 shadow-md" v-loading="loading">
        <h2 class="text-2xl font-bold text-gray-800 mb-6 text-left">
          购买详情
        </h2>

        <el-table :data="selectedDatas" style="width: 100%; margin-bottom: 50px" border size="large">
          <el-table-column label="国家" align="center">
            <template #default="{ row }">
              {{ row.gj_data_item.c_dict_label + " - " + row.gj_data_item.dict_label }}
            </template>
          </el-table-column>
          <el-table-column label="时间" align="center">
            <template #default="{ row }">
              {{ row.price.name }}
            </template>
          </el-table-column>
          <el-table-column prop="num" label="数量" align="center"/>
          <el-table-column label="单价" align="center">
            <template #default="{ row }">
              ￥{{ row.price.price }}
            </template>
          </el-table-column>
          <el-table-column label="小计" align="center">
            <template #default="{ row }">
              ￥{{ (row.num * row.price.price).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template #default="{ $index }">
              <el-button type="danger" size="small" @click="removeItem($index)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="flex justify-between items-center border-t pt-4 border-gray-200">
          <span class="text-xl font-semibold text-gray-800">总价:</span>
          <span class="text-2xl font-bold text-purple-700" id="total_price_us">￥{{ buyTotalPrice }}</span>
        </div>
        <button
            class="buy-now-btn w-full bg-purple-600 text-white py-3 rounded-md mt-6 hover:bg-purple-700 transition duration-300 ease-in-out text-lg font-semibold"
            @click="buy">
          立即购买
        </button>

      </div>

    </main>

    <el-dialog title="选择支付方式" :visible.sync="dialogFormVisible" width="600px" custom-class="payment-dialog">
      <div class="payment-options">
        <div class="payment-title">
          <span class="amount">支付金额：<span class="price">￥{{ buyTotalPrice }}</span></span>
        </div>

        <div class="payment-methods">
          <div class="payment-method" :class="{ active: selectedPaymentMethod === 'balance' }"
               @click="selectedPaymentMethod = 'balance'">
            <i class="fas fa-wallet"></i>
            <span>余额支付</span>
            <div class="check-icon" v-show="selectedPaymentMethod === 'balance'">
              <i class="fas fa-check-circle"></i>
            </div>
          </div>

          <div class="payment-method" :class="{ active: selectedPaymentMethod === 'alipay' }"
               @click="selectedPaymentMethod = 'alipay'">
            <i class="fab fa-alipay"></i>
            <span>支付宝支付</span>
            <div class="check-icon" v-show="selectedPaymentMethod === 'alipay'">
              <i class="fas fa-check-circle"></i>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" plain>取 消</el-button>
        <el-button type="primary" @click="pay" :disabled="!selectedPaymentMethod">
          确认支付
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import api from "@/requset/api";

export default {
  name: "pay_jtzz",
  components: {},
  data() {
    return {
      loading: false,

      gj_data: [],
      selectedLabelsdata: null,

      selectedOption: null,
      items: [],
      dialogFormVisible: false,

      total: 1,

      selectedDatas: [],

      // 支付方式选择
      selectedPaymentMethod: 'balance',

    };
  },
  computed: {
    totalPrice() {
      if (!this.selectedOption || !this.selectedLabelsdata || this.total < 0) return 0;
      return this.selectedOption.price * this.total;
    },
    // 计算购物车总价
    buyTotalPrice() {
      var prices = 0;
      for (const index in this.selectedDatas) {
        prices += Number(this.selectedDatas[index].price.price) * this.selectedDatas[index].num
      }
      return prices;
    },
  },
  mounted() {
  },
  created() {
    this.product_list()
  },
  beforeDestroy() {
  },
  methods: {
    product_list() {
      this.loading = true
      api.product_list({})
          .finally(() => {
            this.loading = false
          })
          .then((res) => {
            if (res.data.error_code != 0) {
              this.$message({
                message: "套餐获取失败，请稍后再试",
                type: "warning",
              });
              return
            }
            this.gj_data = res.data.data;

            if (this.gj_data && this.gj_data.length > 0) {
              this.shop(this.gj_data[0])
            }

          })
          .catch(() => {
          });
    },
    shop(item) {
      if (this.selectedLabelsdata == item) return
      this.selectedLabelsdata = item;

      this.loading = true
      this.items = [];
      this.selectedOption = null;
      api.product_price({
        country: item.c_dict_value,
        city: item.dict_value,
      })
          .finally(() => {
            this.loading = false
          })
          .then((res) => {
            if (res.data.error_code != 0) {
              this.$message({
                message: "套餐获取失败，请稍后再试",
                type: "warning",
              });
              return
            }
            this.items = res.data.data;
            if (this.items && this.items.length > 0) {
              this.selectedOption = this.items[0];
            }
          })
          .catch(() => {
          });
    },
    shichang(item) {
      this.selectedOption = item;
    },
    shoppingCart() {
      if (this.total <= 0) {
        this.$message({
          message: "请选择选择购买ip资源数量",
          type: "warning",
        });
        return
      }
      if (!this.selectedOption) {
        this.$message({
          message: "请选择购买时长",
          type: "warning",
        });
        return
      }

      // 新添加的数据
      const newItem = {
        gj_data_item: this.selectedLabelsdata,
        price: this.selectedOption,
        num: this.total
      }
      // 查找是否有相同的项
      const found = this.selectedDatas.find(item =>
          JSON.stringify(item.price) === JSON.stringify(newItem.price) &&
          JSON.stringify(item.gj_data_item) === JSON.stringify(newItem.gj_data_item)
      );
      if (found) {
        // 已存在，直接累加数量
        found.num = Number(found.num) + Number(newItem.num);
      } else {
        // 不存在，添加新项
        this.selectedDatas.push(newItem);
      }
    },
    removeItem(index) {
      this.selectedDatas.splice(index, 1);
    },
    buy() {
      if (!this.selectedDatas || this.selectedDatas.length <= 0) {
        this.$message({
          message: "购物车为空",
          type: "warning",
        });
        return
      }
      this.dialogFormVisible = true
    },
    pay() {
      if (!this.selectedPaymentMethod) {
        this.$message({
          message: "请选择支付方式",
          type: "warning",
        });
        return;
      }

      this.dialogFormVisible = false;
      this.loading = true;

      // 根据支付方式调用不同的API
      const paymentData = {
        data: this.selectedDatas,
        payment_method: this.selectedPaymentMethod
      };

      api.buy(paymentData)
          .finally(() => {
            this.loading = false;
          })
          .then((res) => {
            if (res.data.error_code != 0) {
              this.$message({
                message: res.data.message,
                type: "warning",
              });
              return;
            }

            if (this.selectedPaymentMethod === 'alipay') {
              // 如果是支付宝支付，跳转到支付页面
              document.write(res.data.data.alipay); // 直接覆盖当前页面
              document.close();
            } else {
              // 余额支付直接完成
              this.$message({
                message: "支付成功",
                type: "success",
              });
              this.$router.push({path: "ucenter", query: {asidename: 'order_list'}});
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: "支付失败，请稍后重试",
              type: "error",
            });
          });
    },

  },
};
</script>
<style scoped>
@import url("https://cdn.bootcdn.net/ajax/libs/font-awesome/6.4.0/css/all.min.css");

/* 支付对话框样式 */
.payment-dialog {
  .el-dialog__body {
    padding: 30px;
  }
}

.payment-options {
  .payment-title {
    text-align: center;
    margin-bottom: 30px;

    .amount {
      font-size: 16px;
      color: #666;

      .price {
        font-size: 24px;
        color: #6327d3;
        font-weight: bold;
        margin-left: 8px;
      }
    }
  }

  .payment-methods {
    display: flex;
    justify-content: space-around;
    gap: 20px;
    padding: 0 20px;

    .payment-method {
      flex: 1;
      height: 100px;
      border: 2px solid #e0e0e0;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      transition: all 0.3s ease;

      &:hover {
        border-color: #6327d3;
        transform: translateY(-2px);
      }

      &.active {
        border-color: #6327d3;
        background-color: #f8f4ff;
      }

      i {
        font-size: 28px;
        color: #6327d3;
        margin-bottom: 8px;
      }

      span {
        font-size: 16px;
        color: #333;
      }

      .check-icon {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #6327d3;
      }
    }
  }
}

/* 美化购物车表格 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

  th {
    background-color: #f8f4ff !important;
    color: #333;
    font-weight: 600;
  }

  td {
    padding: 12px 0;
  }
}

/* 美化按钮 */
.buy-now-btn {
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(120deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent);
    transition: all 0.6s;
  }

  &:hover:before {
    left: 100%;
  }
}

/* 美化数量输入框 */
.el-input-number {
  .el-input__inner {
    border-radius: 8px;
  }
}

/* 美化选择框 */
.form-radio {
  cursor: pointer;

  &:checked {
    background-color: #6327d3;
    border-color: #6327d3;
  }
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.imgstop > div div {
  color: #6327d3;
}

.pay_img_textA > div {
  letter-spacing: 1px;
  margin-left: 7px;
  font-size: 14px;
  color: #100043;
}

.pay_main_body_divB_div_div_div:hover .div_jiajian_butt_text {
  color: #6327d3;
}

.pay_main_body_divB_div_div_div_div_span > span {
  background-color: #6327d3;
  color: #edf3fc;
  /* padding: 5px; */
  line-height: 20px;
  border-radius: 15px;
  font-size: 15px;
  padding-right: 10px;
  padding-left: 10px;
}

.pay_main_body_divB_div_div_div:hover .dov_top {
  transform: translateY(-10px);
}

.pay_main_body_divB_div_div_div:hover .pay_main_body_divB_div_div_div_yhgm {
  background: linear-gradient(90deg, #ffffff, #ffffff);
  color: #6327d3;
  border: 1px solid #6327d3;
}

.pay_main_body_divC_div_div:nth-child(odd) {
  color: #6327d3;
}

.pay_main_body_divC_div_ > div:nth-child(1) {
  width: 80%;
  font-size: 14px;
}

.pay_main_body_divC_div_ > div:nth-child(2) {
  width: 20%;
  font-size: 14px;
  text-align: right;
  white-space: nowrap;
  text-decoration: line-through;
  /* 添加删除线 */
}

.pay_main_body_divC_div_div:hover .div_li_showB {
  opacity: 1;
  width: 150px;
  transition: 0.4s;
}

.pay_main_body_divC_div_div:hover {
  color: #6327d3;
}

.pay_main_body_divC_div_div:hover .pay_main_body_divC_div_div_let {
  color: #6327d3;
}

.pay_main_body_divC_div_div:hover .el-icon-caret-right {
  color: #6327d3;
  opacity: 1;
}

.but_div_ljdz > div {
  margin: 0 auto;
}

.dingzhi1V1 > div {
  margin-right: 20px;
}

.pay_main_body_divE > div {
  width: 1400px;
}

.pay_main_body_divC_main_div {
  width: 1400px;
  height: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.pay_main_body_divC_main_div_divA {
  width: 60%;
  height: 100%;
}

.pay_main_body_divC_main_div_divB {
  width: 40%;
  height: 100%;
}

.div_4 {
  display: flex;
  justify-content: center;
  height: 600px;
  overflow: hidden;
  overflow-y: auto;
}

.div_4 > div {
  margin-top: 50px;
  width: 1400px;
}

.H_qq {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 30px;
  color: #292626;
  width: 100px;
  background: #edf3fc;
  text-align: left;
  margin-top: 30px;
  margin-bottom: 30px;
  white-space: nowrap;
}

.a_text {
  position: relative;
  display: inline-block;
  padding: 8px;
  text-align: left;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  max-width: 214px;
  height: 56px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #f8fbff;
  border: 1px solid #a0c1f7;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 20px;
}

.retop_img {
  position: absolute;
  top: -8px;
  right: -11px;
  transform: rotate(-10deg);
}

.a_texttype {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 20px;
  color: #13497f;
}

.duoxuan {
}

.pay_main_body_divC_main_div_divB_divB_div_div_top {
}

.pay_main_body_divC_main_div_divB_divB_div_div_top > div:nth-child(1) {
  margin-top: 6px;
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #18195a;
}

.pay_main_body_divC_main_div_divB_divB_div_div_top > div:nth-child(2) {
  font-size: 14px;
  color: #6327d3;
  font-family: SourceHanSansCN-Medium;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
}

.pay_div_div_inputs {
  height: 350px;
  overflow: hidden;
  overflow-y: auto;
  margin-bottom: 20px;
}

.div_inputs {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.div_inputs > div {
  font-size: 18px;
  margin-right: 10px;
  color: #100043;
  width: 80px;
  font-size: 14px;
  text-align: left;
}

.div_inputs > div:nth-child(1) {
  height: 10px;
}

.div_inputs > div:nth-child(3) > .el-input-number {
  width: 100px;
  /* margin-top: -5px; */
}

.pay_div_div_nums {
  width: 270px;
  margin: 0 auto;
}

.pay_div_div_nums > div {
  margin-top: 10px;
}

.pay_div_div_nums > div:nth-child(1) {
  text-align: right;
  font-weight: 400;
  font-size: 12px;
  color: #000;
  align-items: center;
  cursor: pointer;
}

.pay_div_div_nums > div:nth-child(2) {
  display: flex;
  justify-content: space-between;
}

.pay_div_div_nums > div:nth-child(3) {
  display: flex;
  justify-content: space-between;
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 16px;
  color: #1b2336;
}

.pay_div_div_nums > div:nth-child(4) {
  width: 100%;
  padding: 10px 0 10px 0;
  line-height: 0.889rem;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  border-radius: 100px;
  background: linear-gradient(152deg, #6327d3 11%, #1b132b);
  font-family: SourceHanSansCN-Medium;
  color: #edf3fc;
}

.pay_div_div_nums > div:nth-child(5) {
  text-align: center;
  font-size: 12px;
  margin-bottom: 10px;
  color: rgba(27, 35, 54, 0.68);
}

.jia_jian_div {
  display: flex;
  justify-content: space-around;
  padding: 2px 0px 2px 0px;
  border: 1px solid #bdbdbd;
  border-radius: 20px;
}

.div_inputs_jian {
  padding: 0 5px 0 5px;
}

.div_inputs_input {
  padding: 0 10px 0 10px;
}

.div_inputs_jia {
  padding: 0 5px 0 5px;
}

.radio-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-bottom: 20px;
  font-size: 15px;
}

.radio-item {
  width: calc(50% - 10px);
  /* 每行显示 2 个 */
  display: flex;
  align-items: center;
}
</style>
